import { observable } from 'mobx';

export type UserMemoResponseArgs = {
  id: number;
  memo: string;
};

export type UserMemoArgs = {
  id: number;
  memo: string;
};

export const convertUserMemoResponseToArgs = (response: UserMemoResponseArgs) => {
  const args: UserMemoArgs = {
    id: response.id,
    memo: response.memo
  };
  return args;
};

export default class UserMemo {
  @observable id: number;
  @observable memo: string;

  constructor(args: UserMemoArgs) {
    this.id = args.id;
    this.memo = args.memo;
  }
}
